// Angular
import { Component, Input } from '@angular/core';


@Component({
  selector: 'pow-icon-toggle[leftIcon][rightIcon]',
  templateUrl: './icon-toggle.component.html',
  styleUrls: ['./icon-toggle.component.scss'],
})
export class IconToggle {

  private _checked?: boolean | null;
  private _danger?: boolean | null;
  private _loading?: boolean | null;

  private _leftIcon?: string | null;
  private _rightIcon?: string | null;

  public get checked(): boolean {
    return this._checked ?? false;
  }

  @Input()
  public set checked(newChecked: boolean | null | undefined) {
    this._checked = newChecked;
  }

  public get danger(): boolean {
    return this._danger ?? false;
  }

  @Input()
  public set danger(newDanger: boolean | null | undefined) {
    this._danger = newDanger;
  }

  public get loading(): boolean {
    return this._loading ?? false;
  }

  @Input()
  public set loading(newLoading: boolean | null | undefined) {
    this._loading = newLoading;
  }

  public get leftIcon(): string | undefined {
    return this._leftIcon ?? undefined;
  }

  @Input()
  public set leftIcon(newLeftIcon: string | null | undefined) {
    this._leftIcon = newLeftIcon;
  }

  public get rightIcon(): string | undefined {
    return this._rightIcon ?? undefined;
  }

  @Input()
  public set rightIcon(newRightIcon: string | null | undefined) {
    this._rightIcon = newRightIcon;
  }

  public get _showLeftIcon(): boolean {
    return !this.loading || this.checked;
  }

  public get _showLeftSpinner(): boolean {
    return this.loading && !this.checked;
  }

  public get _showRightIcon(): boolean {
    return !this.loading || !this.checked;
  }

  public get _showRightSpinner(): boolean {
    return this.loading && this.checked;
  }

}
